import { axiosInstance } from "../config/axiosInstance";
import { InpatientRequestFilterDto, InpatientRequestProcessCreateDto, InpatientRequestResponseWrapper, InpatientRequestDetailsDto } from "./surgeryServiceDtos";
import { useBaseQuery } from "../core/useBaseQuery";

const API_URL = process.env.REACT_APP_API_URL;

// Custom hooks for GET requests with caching
export const useInpatientRequests = (data: InpatientRequestFilterDto) => {
  return useBaseQuery<InpatientRequestResponseWrapper>({
    endpoint: `/surgery/api/InpatientRequest/GetInpatientRequests`,
    queryKey: ['inpatientRequests', data],
  });
};

export const useInpatientOperations = (id: number) => {
  return useBaseQuery<any>({
    endpoint: `/surgery/api/InpatientRequest/GetInpatientOperations/${id}`,
    queryKey: ['inpatientOperations', id],
  });
};

export const useInpatientRequestProcess = (irId: number) => {
  return useBaseQuery<any>({
    endpoint: `/surgery/api/InpatientRequest/GetInpatientRequestProcess/${irId}`,
    queryKey: ['inpatientRequestProcess', irId],
  });
};

export const useCheckInpatientRequestStatus = (irId: number) => {
  return useBaseQuery<any>({
    endpoint: `/surgery/api/InpatientRequest/CheckInpatientRequestStatus/${irId}`,
    queryKey: ['inpatientRequestStatus', irId],
  });
};



export const surgeryService = {
  // /api/surgery/api/InpatientRequest/GetInpatientRequests
  inpatientRequest: {
    getInpatientRequests: async <T = InpatientRequestResponseWrapper>(
      data: InpatientRequestFilterDto
    ): Promise<T> => {
      try {
        const response = await axiosInstance.post<T>(
          `${API_URL}/surgery/api/InpatientRequest/GetInpatientRequests`,
          //"https://localhost:6501/api/InpatientRequest/GetInpatientRequests",
          data
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching inpatient requests:", error);
        throw error;
      }
    },
    
    getInpatientOperations: async <T = any>(id: number): Promise<T> => {
      try {
        const response = await axiosInstance.get<T>(
          `${API_URL}/surgery/api/InpatientRequest/GetInpatientOperations/${id}`
          //"https://localhost:6501/api/InpatientRequest/GetInpatientOperations/${id}"
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching inpatient operations:", error);
        throw error;
      }
    },
    
    getInpatientRequestProcess: async <T = any>(irId: number): Promise<T> => {
      try {
        const response = await axiosInstance.get<T>(
          `${API_URL}/surgery/api/InpatientRequest/GetInpatientRequestProcess/${irId}`
          //"https://localhost:6501/api/InpatientRequest/GetInpatientRequestProcess/${irId}"
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching inpatient request process:", error);
        throw error;
      }
    },

    postCreateInpatientRequestProcess: async <T = any>(data: InpatientRequestProcessCreateDto): Promise<T> => {
      try {
        const response = await axiosInstance.post<T>(
          `${API_URL}/surgery/api/InpatientRequest/CreateInpatientRequestProcess`,
          //"https://localhost:6501/api/InpatientRequest/CreateInpatientRequestProcess",
          data
        );
        return response.data;
      } catch (error) {
        console.error("Error creating inpatient request process:", error);
        throw error;
      }
    },

    getCheckInpatientRequestStatus: async <T = any>(irId: number): Promise<T> => {
      try {
        const response = await axiosInstance.get<T>(
          `${API_URL}/surgery/api/InpatientRequest/CheckInpatientRequestStatus/${irId}`,
          //"https://localhost:6501/api/InpatientRequest/CheckInpatientRequestStatus/${irId}"
        );
        return response.data;
      } catch (error) {
        console.error("Error checking inpatient request status:", error);
        throw error;
      }
    },

    getInpatientRequestDetails: async <T = any>(data: InpatientRequestDetailsDto): Promise<T> => {
      try {
        const response = await axiosInstance.post<T>(
          `${API_URL}/surgery/api/InpatientRequest/GetInpatientRequestDetails`,
          data
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching inpatient request details:", error);
        throw error;
      }
    }
  },
  examinationProcess: {
    getExaminationProcessSummary: async <T = any>(data: {
      ExaminationDate?: string;
      PtId?: number;
      HospitalBuildingId?: number | null;
      HospitalFloorId?: number | null;
      DepartmentId?: number | null;
    }): Promise<T> => {
      try {
        const response = await axiosInstance.post<T>(
          `${API_URL}/surgery/api/ExaminationProcess/GetExaminationProcessSummary`,
          data
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching examination process summary:", error);
        throw error;
      }
    },
    getExaminationStatus: async <T = any>(data: {
      PtId: number;
      ExaminationDate: string;
      PpId: number;
    }): Promise<T> => {
      try {
        const response = await axiosInstance.post<T>(
          `${API_URL}/surgery/api/ExaminationProcess/GetExaminationStatus`,
          data
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching examination status:", error);
        throw error;
      }
    },
    changeExaminationStatus: async <T = any>(data: {
      ptid: number;
      ppid: number;
      psid: number;
      upn: number;
      status: string;
    }): Promise<T> => {
      try {
        const response = await axiosInstance.post<T>(
          `${API_URL}/surgery/api/ExaminationProcess/ChangeExaminationStatus`,
          data
        );
        return response.data;
      } catch (error) {
        console.error("Error changing examination status:", error);
        throw error;
      }
    }
  },
};

export default surgeryService;
